import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import Loading from 'components/Loading/Loading'
import Api from '../../api/Api.js';
import EmailEndpoints from '../../api/EmailEndpoints';

const styles = {
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    infoBar: {
        padding: '10px 18px',
        display: 'flex',
        flexDirection: 'row',
        "& :first-child": {
            display: 'block',
            width: 75
        },
        "& :last-child": {
            flex: 1
        }
    },
    strongChildren: {
        "& strong": {
            fontWeight: 'bold'
        }
    }
};

const Transition = (props) => {
    return <Slide direction="up" {...props} />;
}

class EmailPreview extends Component {

    state = {
        lastRenderedBody: '',
        lastLetterhead: 'Cellfind',
        bodyLoading: true,
        serverPreview: ''
    }

    fetchHtml() {
        Api.post(EmailEndpoints.preview, { body: this.props.body() || '', letterhead: this.props.letterhead || 'Cellfind' })
            .then(({ data }) => {
                //console.log(data);
                this.setState({ serverPreview: data, bodyLoading: false })
            })
    }

    render() {

        const { classes } = this.props;

        const currentBody = this.props.body && this.props.body();

        if (currentBody !== this.state.lastRenderedBody || this.props.letterhead !== this.state.lastLetterhead)
            this.setState({ lastRenderedBody: currentBody, bodyLoading: true, lastLetterhead: this.props.letterhead }, () => this.fetchHtml())

        return (
            <Dialog
                fullScreen
                open={this.props.open}
                onClose={this.props.close}
                TransitionComponent={Transition}
                TransitionProps={{ onExited: this.props.onExited }}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.close} aria-label="Close" style={{ marginRight: 10 }}>
                            <CloseIcon />
                        </IconButton>
                        <h4 className={classes.flex}>
                            Email Preview
                        </h4>
                        <Button color="inherit" onClick={() => { this.props.close && this.props.close(); this.props.onTemplateClick && this.props.onTemplateClick(); }} style={{ marginRight: 10 }}>
                            <FontAwesomeIcon icon={faBookmark} />&nbsp;&nbsp;&nbsp;save as template
                        </Button>
                        <Button color="inherit" onClick={() => { this.props.close && this.props.close(); this.props.onSendClick && this.props.onSendClick(); }}>
                            <FontAwesomeIcon icon={faPaperPlane} />&nbsp;&nbsp;&nbsp;send
                        </Button>
                    </Toolbar>
                </AppBar>
                <div className={classes.strongChildren} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <div className={classes.infoBar}>
                        <strong>From:</strong>
                        <div>
                            {this.props.from}
                        </div>
                    </div>
                    <Divider />
                    <div className={classes.infoBar}>
                        <strong>To:</strong>
                        <div>
                            {this.props.to && this.props.to()}
                        </div>
                    </div>
                    <Divider />
                    <div className={classes.infoBar}>
                        <strong>CC:</strong>
                        <div>
                            {this.props.cc && this.props.cc()}
                        </div>
                    </div>
                    <Divider />
                    <div className={classes.infoBar}>
                        <strong>BCC:</strong>
                        <div>
                            {this.props.bcc && this.props.bcc()}
                        </div>
                    </div>
                    <Divider />
                    <div className={classes.infoBar}>
                        <strong>Subject:</strong>
                        <div>
                            {this.props.subject && this.props.subject()}
                        </div>
                    </div>
                    <Divider />
                    <div style={{ flex: 1, display: 'flex', minHeight: '100%' }}>
                        {
                            currentBody ?
                                this.state.serverPreview && !this.state.bodyLoading ?
                                    <iframe
                                        src={`data:text/html;charset=utf-8,${encodeURIComponent(this.state.serverPreview)}`}
                                        //srcdoc={this.state.serverPreview}
                                        style={{ flex: 1, width: '100%', border: 'none' }}
                                    >
                                    </iframe>
                                    :
                                    <Loading />
                                :
                                <Loading />
                        }
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withStyles(styles)(EmailPreview);